module.exports = "/_next/static/images/heroSection-fe2106deffd71a3de04171a1f67addf2.webp";